import React, { Component } from "react";

class FormWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = { submitting: false };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFilesSelection = this.handleFilesSelection.bind(this);
    this.doSubmit = this.doSubmit.bind(this);
    this.callbackForMyMap = this.props.callbackForMyMap;
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleFilesSelection = (e) => {
    const target = e.target;
    const value = target.files[0];
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  /**
   * Handle submit
   * @param {Object<>} e : event
   * @see https://github.com/sw-yx/gatsby-netlify-form-example-v2/blob/master/src/pages/contact.js
   * @see https://www.netlify.com/blog/2017/07/20/how-to-integrate-netlifys-form-handling-in-a-react-app/
   */
  doSubmit(e) {
    e.preventDefault();

    if (this.state.submitting) {
      return;
    }

    this.setState({
      submitting: true,
    });

    try {
      const name = e.target.getAttribute("name");

      if (e.target.checkValidity()) {
        let formData = encode({
          "form-name": name,
          "contact-path": window.location.href,
          ...this.state,
        });

        fetch("/", {
          method: "POST",
          body: formData,
        })
          .then(() => this.doSuccess(name))
          .catch((error) => this.doError(name, error));
      }
    } catch (ex) {
      this.doError(ex);
    }
  }

  doSuccess(name) {
    this.triggerGaEvent(true, name);

    if (this.props.onSuccess) {
      this.props.onSuccess();
      return;
    }

    this.setState({
      submitting: false,
      formState: "success",
    });

    this.callbackForMyMap(true);
  }

  doError(name, message) {
    this.triggerGaEvent(false, name);
    this.setState({
      submitting: false,
      formState: "error",
    });
    this.callbackForMyMap(true);
    console.error(message);
  }

  triggerGaEvent(success, formName) {
    if (window && window.ga && typeof window.ga === "function") {
      window.ga(
        "send",
        "event",
        "form",
        success ? "submit-success" : "submit-fail",
        formName
      );
    }
  }

  render() {
    const children = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        handleChange: this.handleInputChange,
        handleFilesSelection: this.handleFilesSelection,
        submitForm: this.doSubmit,
        formState: this.state.formState,
        fileName: this.state.fileName,
        path: this.props.path,
      });
    });

    return <>{children}</>;
  }
}

function encode(data) {
  const formData = new FormData();

  for (const key of Object.keys(data)) {
    formData.append(key, data[key]);
  }

  return formData;
}

export default FormWrapper;
